import clsx from '@repo/shared/utils/cn';
import { useMemo } from 'react';
import { VARIANT_STYLES } from './constants';
import style from './index.module.css';
import type { SkeletonProps } from './index.types';

export const Skeleton = (props: SkeletonProps) => {
	const {
		loading = true,
		variant = 'overlay',
		level = variant === 'text' ? 'body-md' : 'inherit',
		height,
		width,
		children,
		className,
	} = props;

	const baseStyles = useMemo(
		() =>
			clsx(
				style.root,
				className,
				level !== 'inherit' && level,
				'overflow-hidden text-transparent cursor-default',
			),
		[className, level],
	);

	const variantStyles = useMemo(
		() =>
			clsx({
				[style.defaultRadius as string]: variant !== 'circular',
				[VARIANT_STYLES[variant] as string]: true,
				[style.text as string]: variant === 'text',
				'before:absolute': variant !== 'text',
			}),
		[variant],
	);

	const rootStyles = useMemo(
		() => ({
			width: typeof width === 'number' ? `${width}px` : width,
			height: typeof height === 'number' ? `${height}px` : height,
		}),
		[width, height],
	);

	if (loading) {
		return (
			<span className={clsx(baseStyles, variantStyles)} style={rootStyles}>
				{children}
			</span>
		);
	}

	return children;
};

Skeleton.iuiName = 'Skeleton';
